import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoToastModule } from '@go-modules/components/go-toast/go-toast.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FolderMenuComponent } from './folder-menu.component';
import { MoveFolderDialogModule } from '@go-modules/components/dialogs/move-folder-dialog/move-folder-dialog.module';
import { InviteUsersDialogModule } from '@go-modules/components/dialogs/invite-users-dialog/invite-users-dialog.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		GoToastModule,
		MoveFolderDialogModule,
		InviteUsersDialogModule
	],
	declarations: [
		FolderMenuComponent
	],
	exports: [
		FolderMenuComponent
	],
	providers: [
		TranslatePipe
	]
})
export class FolderMenuModule {}
